(function (root) {
  'use strict';
  const PREFIX = 'cs_';
  const validGroup = (value) => /^[a-z][a-z0-9_-]{0,40}$/.test(value);
  const validValue = (value) => /^[a-z0-9][a-z0-9-]{0,100}$/.test(value);

  function read(search, groups) {
    const params = new URLSearchParams(search);
    const state = {};
    (groups || ['collection', 'format', 'design']).filter(validGroup).forEach(function (key) {
      const values = Array.from(new Set(params.getAll(PREFIX + key).flatMap(function (value) { return value.split(','); }).filter(validValue)));
      if (values.length) state[key] = values;
    });
    return state;
  }

  function matches(key, selected, value) {
    return selected.includes(value) ||
      (key === 'design' && selected.includes('collabs') && value.endsWith('-collab')) ||
      (key === 'format' && selected.includes('underwear') && /(?:underwear|boxer-briefs)/.test(value));
  }

  function expand(key, selected, available) {
    return available.filter(function (value) { return matches(key, selected, value); });
  }

  function pendingSelections(search, groups) {
    const labels = {
      underwear: 'UNDERWEAR',
      customize: 'CUSTOMIZE',
      collabs: 'COLLABS',
      'nfl-players': 'NFL PLAYERS',
    };
    const state = read(search, groups);
    return Object.keys(state).flatMap(function (key) {
      return state[key].map(function (value) {
        return {
          filter: key,
          value: value,
          label: labels[value] || value.replace(/-/g, ' ').toUpperCase(),
        };
      });
    });
  }

  function collectionLabel(raw) {
    const value = String(raw || '').trim();
    const aliases = {
      'Casual Patterns': 'CASUAL & PATTERNS',
      Holidays: 'HOLIDAYS & SEASONS',
      'Holidays, Seasons & Occasions': 'HOLIDAYS & SEASONS',
      Music: 'MUSIC INSPIRED',
      Nautical: 'BEACH & OCEAN',
      Puns: 'PUNS & JOKES',
      'Puns & Jokes': 'PUNS & JOKES',
      'Aliens & Space': 'SCIENCE, TECH & EDUCATION',
      'Space & Tech': 'SCIENCE, TECH & EDUCATION',
    };
    return aliases[value] || value.toUpperCase();
  }

  function urlForState(href, state, groups) {
    const url = new URL(href);
    (groups || ['collection', 'format', 'design']).filter(validGroup).forEach(function (key) { url.searchParams.delete(PREFIX + key); });
    Object.entries(state || {}).forEach(function ([key, values]) {
      if (!validGroup(key) || !Array.isArray(values)) return;
      const selected = Array.from(new Set(values.filter(validValue)));
      if (selected.length) url.searchParams.set(PREFIX + key, selected.join(','));
    });
    url.searchParams.delete('page');
    return url.pathname + url.search + url.hash;
  }

  function restore(sidebar, search) {
    const boxes = Array.from(sidebar.querySelectorAll('.cs-checkbox'));
    const groups = Array.from(new Set(boxes.map(function (box) { return box.dataset.filter; })));
    const requested = read(search, groups);
    const selected = {};
    groups.forEach(function (key) {
      selected[key] = expand(key, requested[key] || [], boxes.filter(function (box) { return box.dataset.filter === key; }).map(function (box) { return box.dataset.value; }));
    });
    boxes.forEach(function (box) { box.checked = selected[box.dataset.filter].includes(box.dataset.value); });
  }

  function write(state, groups) {
    const next = urlForState(root.location.href, state, groups);
    const current = root.location.pathname + root.location.search + root.location.hash;
    if (next !== current) root.history.pushState(root.history.state, '', next);
  }

  const api = { read: read, matches: matches, expand: expand, pendingSelections: pendingSelections, collectionLabel: collectionLabel, urlForState: urlForState, restore: restore, write: write };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CollectionFilterLinks = api;
})(typeof window === 'undefined' ? {} : window);
